import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AgeDistributionCakeGraphic from './AgeDistributionCakeGraphic';
import Men from '../images/Men.png';
import Women from '../images/Women.png';

function AgeDistribution({ title = '', subtitle = '', onRequest = false }) {
  let men = '';
  let fem = '';

  let NumberMen = 0;
  let NumberWomen = 0;

  let totalMen = 0;
  let totalWomen = 0;

  let totaldata = 0;
  let totaldatapercentage = 0;

  const GenderValues = {};

  if (typeof subtitle === 'object' && typeof title === 'object') {
    men = subtitle?.Masculino;
    fem = subtitle?.Femenino;

    NumberMen = title[0]?.men;
    NumberWomen = title[0]?.women;

    totalMen =
      NumberMen[0]?.range1 + NumberMen[0]?.range2 + NumberMen[0]?.range3 + NumberMen[0]?.range4 + NumberMen[0]?.range5;
    totalWomen =
      NumberWomen[0]?.range1 +
      NumberWomen[0]?.range2 +
      NumberWomen[0]?.range3 +
      NumberWomen[0]?.range4 +
      NumberWomen[0]?.range5;

    Object.keys(subtitle).forEach(groupbygender => {
      totaldata += subtitle[groupbygender];
    });

    Object.keys(subtitle).forEach(groupbygender => {
      totaldatapercentage += (subtitle[groupbygender] / totaldata) * 100;

      if (totaldatapercentage === 100) {
        totaldatapercentage += 1;
      }
      GenderValues[groupbygender] = totaldatapercentage;
    });
  }

  return (
    <>
      {!onRequest && (
        <div>
          <Row>
            <Col xl={12} md={12} xs={12} className="adjust-pad">
              <div className="AgeDistributionGraphic">
                <Row>
                  <Col xs={12} md={12} xl={12}>
                    <AgeDistributionCakeGraphic
                      label="Hombres"
                      color="#f8c444"
                      gender={men}
                      image={Men}
                      percentage={`${Math.round((totalMen / totaldata) * 100)}%`}
                    />
                  </Col>
                  <Col xs={12} md={12} xl={12}>
                    <AgeDistributionCakeGraphic
                      label="Mujeres"
                      color="#8054fc"
                      gender={fem}
                      image={Women}
                      percentage={`${Math.round((totalWomen / totaldata) * 100)}%`}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default AgeDistribution;
